import UploadForm from './UploadForm';

export default UploadForm;
